module.exports = __webpack_public_path__ + "img/favIcon.e5d14b89.svg";